import { type ManipulateType } from 'dayjs';

export enum Interval {
  Year = 'Year',
  Month = 'Month',
  Week = 'Week',
  Day = 'Day',
  Hour = 'Hour',
  Custom = 'Custom',
}

export enum MetricVisual {
  Graph = 'Graph',
  Table = 'Table',
}

export type MetricView = {
  interval: Interval;
  visual: MetricVisual;
  range: number;
};

export const INTERVALS: Record<Interval, number> = {
  [Interval.Year]: 0,
  [Interval.Month]: 1,
  [Interval.Week]: 2,
  [Interval.Day]: 3,
  [Interval.Hour]: 4,
  [Interval.Custom]: 10,
};

export const DAYJS_MAP: Record<
  Exclude<Interval, Interval.Custom>,
  ManipulateType
> = {
  [Interval.Hour]: 'hour',
  [Interval.Day]: 'day',
  [Interval.Week]: 'week',
  [Interval.Month]: 'month',
  [Interval.Year]: 'year',
};

export const FRIENDLY_CODE_NAME_MAP: Record<string, string> = {
  systolic: 'Systolic',
  diastolic: 'Diastolic',
};

export const MOBILE_INTERVAL_RANGES = new Map<Interval, number[]>([
  [Interval.Custom, [1]],
  [Interval.Hour, [1, 6, 12]],
  [Interval.Day, [1, 3]],
  [Interval.Week, [1, 2, 3]],
  [Interval.Month, [1, 3, 6]],
  [Interval.Year, [1, 3, 5]],
]);

export const WEB_INTERVAL_RANGES = new Map<Interval, number[]>([
  [Interval.Custom, []],
  [Interval.Hour, [1, 6, 12]],
  [Interval.Day, [3]],
  [Interval.Week, [2, 3]],
  [Interval.Month, [3, 6]],
  [Interval.Year, [3, 5]],
]);
